<ng-container *ngIf="selectedOption">
  <input
    class="dropdown-sidepanel__input"
    [class.dropdown-sidepanel__input--active-placeholder]="activePlaceHolder"
    [(ngModel)]="selectedOption[optionLabel]"
    readonly
    pInputText
    type="text"
    (click)="openSelectorComponent()"
    (keydown.enter)="openSelectorComponent()"
    data-qa="dropdownSidePanelField_input"
    name="dropdownInput"
    [autocomplete]="autocomplete"
  />
</ng-container>

<lx-side-panel [title]="title" [visible]="dialogVisible" (hiddenPanel)="hideDialog()" size="large" data-qa="dropdownSidePanelField_sidePanel">
  <div class="dropdown-sidepanel__container">
    <div class="sticky-search-bar">
      <lx-searcher
        *ngIf="filter"
        (searchTriggered)="filterOption($event)"
        data-qa="dropdownSidePanelField_searchInput"
        [queryReset]="dialogVisible"
        [autofocus]="dialogVisible"
      ></lx-searcher>
    </div>

    <div class="listbox-options listbox-options--margin">
      <lx-list-box
        [options]="filteredOptions"
        [ngModel]="selectedValue"
        (ngModelChange)="updateSelectedOption($event)"
        [optionLabel]="optionLabel"
        [optionValue]="optionValue"
        lxListboxScrollToSelectedItem
        [scrollWhenVisible]="dialogVisible"
        i18n-emptyMessage
        emptyMessage="No results found"
        data-qa="dropdownSidepanelField__list"
      >
        <ng-template *ngIf="itemTemplate" #customItemTemplate pTemplate="item" let-item>
          <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
        </ng-template>
      </lx-list-box>
    </div>
  </div>
</lx-side-panel>
